import React from 'react';
import './Section.css';
import './Achievements.css';

const achievements = [
  {
    title: '1st Runner Up — HackSecureX International Hackathon 2026',
    date: 'Jan 2026',
    desc: 'Secured a $500 prize by pitching product vision and technical feasibility to international judges in a global competition organized by UTEP, USF, and SUNY Polytechnic.',
    badge: '🥈',
    highlight: true,
    prize: '$500 Prize',
  },
  {
    title: 'Innovation Award — Cyber AI Hackathon 2025',
    date: 'Nov 2025',
    desc: 'Led a team of developers to deliver a working prototype under strict deadlines, winning the Innovation Award for unique value proposition. Awarded by University of Derby, UK.',
    badge: '🏅',
    highlight: true,
    prize: 'Innovation Award',
  },
  {
    title: 'National Finalist — Hack the Future 2025',
    date: 'Mar 2025',
    desc: 'Selected as a national finalist in the prestigious hackathon organized by MOSPI and IIT Gandhinagar — the NIC Code Classifier project representing the submission.',
    badge: '🎯',
    highlight: false,
    prize: 'National Finalist',
  },
  {
    title: 'Research Publication (Ongoing) — MPCE Prediction',
    date: 'Mar 2025',
    desc: 'Developing a research paper on predicting Monthly Per Capita Household Expenditure using machine learning on large-scale household survey data from HCES.',
    badge: '📄',
    highlight: false,
    prize: 'Research Paper',
  },
];

export default function Achievements() {
  return (
    <section id="achievements" className="section">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-num">05.</span>
          <h2 className="section-title">achievements</h2>
          <div className="section-line" />
        </div>

        <div className="achievements-list">
          {achievements.map((a, i) => (
            <div key={i} className={`achievement-item ${a.highlight ? 'highlighted' : ''}`}>
              <div className="ach-left">
                <div className="ach-badge">{a.badge}</div>
                <div className="ach-connector" />
              </div>
              <div className="ach-content">
                <div className="ach-top">
                  <h3 className="ach-title">{a.title}</h3>
                  <div className="ach-meta">
                    <span className="ach-prize">{a.prize}</span>
                    <span className="ach-date">{a.date}</span>
                  </div>
                </div>
                <p className="ach-desc">{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
